(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('packageAvailableProductsTable', function () {
		return {
			scope: {
				package: '=',
				store: '='
			},
			templateUrl:'directives/packageAvailableProductsTable/table.html',
			controller: function($scope) {

				$scope.add = function(product) {
                    console.log('packageAvailableProductsTable -> product', product);
					if (!$scope.package.products){
                        // $scope.package.products = [angular.copy(product)];
                        $scope.package.products = [{id: product.id, name: product.name}];
                    } else {
                        // if(_.find($scope.package.products, {name: product.name})){
                        if(_.find($scope.package.products, {id: product.id})){
                            alert(product.name + ' is already in the package.');
                            return; // product is already in the package
                        } else {
                            //$scope.package.products.push(angular.copy(product));
                            $scope.package.products.push({id: product.id, name: product.name});
                        }
                    }
				};
			}
		};
	});
})();
